import type { Skill } from '../skillsData';

export const cryptoskillChainsExtraData: Skill[] = [
  {
    id: 'aaveclaw',
    name: 'aaveclaw',
    author: 'AaveClaw',
    authorHandle: '@aaveclaw',
    tag: 'Skill',
    category: 'defi',
    description: 'Enhanced Aave lending automation with claw-back mechanics, automated deleveraging, and liquidation protection strategies.',
    downloads: 7400,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the aaveclaw skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/aaveclaw',
    usageExample: '> setup deleveraging trigger\n> enable liquidation protection\n> automate claw-back',
    detailedDescription: 'AaveClaw enhances Aave V3 lending with automated claw-back mechanics. Configure automatic deleveraging triggers to prevent liquidations, monitor health factors in real time, and execute protective actions when risk thresholds are breached.',
    trending: true,
  },
  {
    id: 'icp-official-icskills',
    name: 'icp-official-icskills',
    author: 'DFINITY',
    authorHandle: '@dfinity',
    tag: 'Skill',
    category: 'tools',
    description: 'Official DFINITY icSkills for Internet Computer. Extended canister operations, HTTP outcalls, threshold signatures, and on-chain AI inference.',
    downloads: 11200,
    stars: 510,
    version: '1.1.0',
    installCommand: '> install the icp-official-icskills skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/icp-official-icskills',
    usageExample: '> execute canister HTTP outcall\n> request threshold ECDSA\n> run on-chain AI inference',
    detailedDescription: 'Official DFINITY icSkills package for the Internet Computer Protocol. Execute HTTP outcalls from canisters, request threshold ECDSA/Schnorr signatures, run on-chain AI inference, and interact with the Bitcoin and Ethereum integrations native to ICP.',
  },
  {
    id: 'lightning-security',
    name: 'lightning-security',
    author: 'Lightning Labs',
    authorHandle: '@lightning',
    tag: 'Skill',
    category: 'tools',
    description: 'Bitcoin Lightning Network security toolkit. Channel watchtowers, breach detection, force-close prevention, and routing privacy.',
    downloads: 5200,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the lightning-security skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/lightning-security',
    usageExample: '> setup channel watchtower\n> detect breach attempt\n> enable routing privacy',
    detailedDescription: 'Bitcoin Lightning Network security suite. Set up automated watchtowers to detect and penalize channel breaches, prevent unilateral force-closes, implement onion routing privacy for payments, and monitor for probing attacks.',
  },
  {
    id: 'muto-ai-agent',
    name: 'muto-ai-agent',
    author: 'Muto AI',
    authorHandle: '@mutoai',
    tag: 'Skill',
    category: 'tools',
    description: 'Muto AI autonomous blockchain agent. Multi-chain task planning, autonomous contract deployment, and on-chain decision making.',
    downloads: 8600,
    stars: 390,
    version: '1.2.0',
    installCommand: '> install the muto-ai-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/muto-ai-agent',
    usageExample: '> plan multi-chain task\n> deploy contract autonomously\n> execute on-chain decision',
    detailedDescription: 'Muto AI delivers autonomous blockchain agent capabilities. Plan and execute multi-chain task sequences, deploy smart contracts programmatically, and make autonomous on-chain decisions based on real-time data and configurable rules.',
    trending: true,
  },
  {
    id: 'nexus-node-depin',
    name: 'nexus-node-depin',
    author: 'Nexus',
    authorHandle: '@nexus_xyz',
    tag: 'Skill',
    category: 'tools',
    description: 'Nexus zkVM DePIN node operations. Prover node management, proof contribution tracking, and NXP token rewards.',
    downloads: 6200,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the nexus-node-depin skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/nexus-node-depin',
    usageExample: '> manage prover node\n> track proof contributions\n> claim NXP rewards',
    detailedDescription: 'Nexus zkVM DePIN integration. Manage prover nodes contributing to the Nexus zero-knowledge proof network, track proof submission history and contribution metrics, and claim NXP token rewards for computation work.',
  },
  {
    id: 'real-thrill-agent-chains',
    name: 'real-thrill-agent',
    author: 'RealThrill',
    authorHandle: '@realthrill',
    tag: 'Skill',
    category: 'defi',
    description: 'Real-world asset DeFi integration agent. Tokenize physical assets, manage RWA collateral, and bridge off-chain yield on-chain.',
    downloads: 5800,
    stars: 260,
    version: '1.0.0',
    installCommand: '> install the real-thrill-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/real-thrill-agent',
    usageExample: '> tokenize physical asset\n> manage RWA collateral\n> bridge off-chain yield',
    detailedDescription: 'Real-world asset (RWA) DeFi integration. Tokenize physical assets through verified oracles, manage RWA collateral positions across lending protocols, and bridge off-chain yield streams onto blockchain networks.',
  },
  {
    id: 'sui-jsonrpc',
    name: 'sui-jsonrpc',
    author: 'Sui',
    authorHandle: '@mysten_labs',
    tag: 'Skill',
    category: 'tools',
    description: 'Sui JSON-RPC API interface. Direct access to Sui full node RPC methods, batch requests, and event subscriptions.',
    downloads: 7800,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the sui-jsonrpc skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/sui-jsonrpc',
    usageExample: '> call Sui RPC method\n> batch query objects\n> subscribe to events',
    detailedDescription: 'Direct Sui JSON-RPC interface. Call any Sui full node RPC method, send batched object queries for efficiency, subscribe to real-time event streams, and handle complex response types with full type safety.',
  },
  {
    id: 'xrpl-tx-builder',
    name: 'xrpl-tx-builder',
    author: 'Ripple',
    authorHandle: '@ripple',
    tag: 'Skill',
    category: 'tools',
    description: 'XRP Ledger advanced transaction builder. Multi-signing, escrow conditions, offer management, and NFT operations on XRPL.',
    downloads: 8200,
    stars: 380,
    version: '1.0.0',
    installCommand: '> install the xrpl-tx-builder skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/xrpl-tx-builder',
    usageExample: '> build multi-sig XRPL tx\n> create escrow with condition\n> manage offer book',
    detailedDescription: 'Advanced XRP Ledger transaction builder. Construct multi-signature transactions with threshold key management, create conditional escrows with crypto conditions, manage DEX offer books, and mint/transfer NFTs on the XRPL native NFT standard.',
  },
  {
    id: 'bnblchain-mcp',
    name: 'bnblchain-mcp',
    author: 'BNB Chain',
    authorHandle: '@bnbchain',
    tag: 'Skill',
    category: 'tools',
    description: 'BNB L1 Chain MCP protocol implementation. Layer-1 BSC data access, validator queries, and governance interaction via MCP.',
    downloads: 4600,
    stars: 210,
    version: '1.0.0',
    installCommand: '> install the bnblchain-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/bnblchain-mcp',
    usageExample: '> query BSC L1 validators\n> access governance data\n> interact via MCP protocol',
    detailedDescription: 'BNB L1 Chain Model Context Protocol implementation. Query validator and staking data on BSC Layer-1, access governance proposal states, and interact with BNB Chain infrastructure via the standardized MCP interface.',
  },
  {
    id: 'base-chain',
    name: 'base',
    author: 'Coinbase',
    authorHandle: '@coinbase',
    tag: 'Skill',
    category: 'tools',
    description: 'Base L2 blockchain core operations. Unified Base chain interface for transactions, contract calls, and OP Stack interactions.',
    downloads: 38400,
    stars: 1820,
    version: '3.0.0',
    installCommand: '> install the base skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/base',
    usageExample: '> execute Base transaction\n> call Base contract\n> interact with OP Stack',
    detailedDescription: 'Core Base L2 blockchain integration. Execute transactions on Base mainnet and testnet, interact with smart contracts, leverage OP Stack capabilities, manage bridging to/from Ethereum, and integrate with Coinbase Developer Platform tools.',
    featured: true,
    trending: true,
  },
  {
    id: 'chainlink-chain',
    name: 'chainlink',
    author: 'Chainlink',
    authorHandle: '@chainlink',
    tag: 'Skill',
    category: 'tools',
    description: 'Chainlink core integration. Data feeds, CCIP cross-chain messaging, VRF randomness, and Chainlink Automation scheduler.',
    downloads: 29800,
    stars: 1420,
    version: '2.5.0',
    installCommand: '> install the chainlink skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/chainlink',
    usageExample: '> get ETH/USD price feed\n> send CCIP message\n> register Automation upkeep',
    detailedDescription: 'Comprehensive Chainlink oracle integration. Access 1000+ decentralized price and data feeds, send cross-chain messages via CCIP, request verifiable randomness with VRF, and schedule contract automation with Chainlink Automation.',
    featured: true,
    trending: true,
  },
  {
    id: 'hedera-chain',
    name: 'hedera',
    author: 'Hedera',
    authorHandle: '@hedera',
    tag: 'Skill',
    category: 'tools',
    description: 'Hedera Hashgraph full integration. HBAR, HCS, HTS, HSS, and Hedera smart contract service in a single unified skill.',
    downloads: 12400,
    stars: 580,
    version: '2.1.0',
    installCommand: '> install the hedera skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/chains/hedera',
    usageExample: '> transfer HBAR\n> submit HCS message\n> create HTS token',
    detailedDescription: 'Unified Hedera Hashgraph integration combining all Hedera services. Transfer HBAR, submit messages to Hedera Consensus Service, create and manage tokens via HTS, store files with HFS, and deploy/call smart contracts on Hedera EVM.',
  },
];